export const COMMISSION_PERCENTS = parseFloat(
  process.env.VUE_APP_COMMISSION_PERCENTS
);
export const COMMISSION_DECIMAL =
  parseFloat(process.env.VUE_APP_COMMISSION_PERCENTS) / 100;
export const COMMISSION_MIN_AMOUNT_UAH = parseFloat(
  process.env.VUE_APP_COMMISSION_MIN_AMOUNT_UAH
);
